export default "__VITE_ASSET__BBwSZzYE__"